module.exports = __webpack_public_path__ + "img/icon-centros.20c24750.svg";